module.exports = __webpack_public_path__ + "img/QRCODEODM.1128b276.png";